"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Authentication_module_1 = require("./modules/Authentication.module");
const loadShoppingBudgetModule = () => ({
    hasRouter: false,
    modules: [(0, Authentication_module_1.default)()],
});
exports.default = loadShoppingBudgetModule;
